export const cardsData = [
  {
    id: 1,
    title: '顶流男星深夜密会网红，酒店监控实锤流出',
    summary: '近日有知情人士爆料，某顶流男星与知名网红在酒店私会长达六小时，酒店监控画面已流出，粉丝后援会紧急回应。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20gossip%20breaking%20news%20celebrity%20scandal%20dramatic%20dark%20moody%20lighting%20paparazzi%20style%20photography%20warm%20red%20and%20black%20tones&width=800&height=600&seq=card-01&orientation=landscape',
    tag: '实锤曝光',
    date: '2026-07-18',
    hot: true,
  },
  {
    id: 2,
    title: '知名女主播偷税被罚千万，直播间已被永久封禁',
    summary: '税务部门通报某头部女主播涉嫌偷逃税款，金额高达数千万，目前其所有社交账号已被平台永久封禁处理。',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20breaking%20news%20scene%20with%20warning%20signs%20and%20red%20alert%20theme%20dark%20background%20with%20warm%20accents%20editorial%20photography&width=800&height=600&seq=card-02&orientation=landscape',
    tag: '明星塌房',
    date: '2026-07-17',
    hot: true,
  },
  {
    id: 3,
    title: '素人情侣分手互爆黑料，聊天记录全网疯传',
    summary: '一对校园素人情侣分手后互撕，双方在社交平台公开大量私密聊天记录和照片，引发全网吃瓜群众围观。',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20social%20media%20controversy%20scene%20with%20phone%20screens%20and%20chat%20messages%20dark%20moody%20atmosphere%20warm%20red%20glow&width=800&height=600&seq=card-03&orientation=landscape',
    tag: '素人爆料',
    date: '2026-07-17',
    hot: false,
  },
  {
    id: 4,
    title: '综艺节目录制现场冲突，两位导师当场翻脸',
    summary: '某热门综艺录制过程中两位导师因意见不合发生激烈争执，节目组紧急叫停，现场观众拍摄视频流出。',
    image: 'https://readdy.ai/api/search-image?query=TV%20show%20studio%20conflict%20scene%20with%20dramatic%20lighting%20and%20tension%20two%20people%20arguing%20on%20stage%20warm%20orange%20and%20red%20tones&width=800&height=600&seq=card-04&orientation=landscape',
    tag: '娱乐大事件',
    date: '2026-07-16',
    hot: false,
  },
  {
    id: 5,
    title: '某男团队内不和实锤，后台争吵录音独家曝光',
    summary: '爆料人提供了一段某当红男团后台争吵的录音，成员之间矛盾已久，经纪公司至今未正面回应。',
    image: 'https://readdy.ai/api/search-image?query=behind%20the%20scenes%20kpop%20boy%20band%20drama%20tense%20atmosphere%20dark%20backstage%20area%20with%20warm%20dramatic%20lighting%20mysterious%20vibe&width=800&height=600&seq=card-05&orientation=landscape',
    tag: '独家深扒',
    date: '2026-07-16',
    hot: true,
  },
  {
    id: 6,
    title: '网红夫妻婚变内幕：第三者竟然是圈内好友',
    summary: '拥有千万粉丝的网红夫妻被曝已分居数月，婚变原因疑似涉及双方共同圈内好友，细节令人震惊。',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20relationship%20scandal%20scene%20with%20broken%20heart%20symbolism%20dark%20romantic%20moody%20atmosphere%20warm%20red%20and%20black%20artistic%20photography&width=800&height=600&seq=card-06&orientation=landscape',
    tag: '网红八卦',
    date: '2026-07-15',
    hot: false,
  },
  {
    id: 7,
    title: '选秀出道艺人被前经纪人实名举报造假',
    summary: '一位通过选秀节目出道的艺人被前经纪人实名举报学历造假、年龄造假，并提供了多份关键证据材料。',
    image: 'https://readdy.ai/api/search-image?query=breaking%20news%20expose%20style%20scene%20with%20documents%20and%20evidence%20on%20dark%20desk%20dramatic%20lighting%20warm%20orange%20accents%20investigative%20journalism&width=800&height=600&seq=card-07&orientation=landscape',
    tag: '实锤曝光',
    date: '2026-07-15',
    hot: true,
  },
];

export const commentsData = [
  {
    id: 1,
    author: '吃瓜不嫌事大',
    role: '资深瓜友',
    content: '91吃瓜真的yyds！每次有大事发生我第一个打开的就是这里，信息更新比微博还快，而且很多独家爆料别的平台根本看不到。上次那个顶流塌房事件，91吃瓜提前三天就发了预警帖！',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20of%20young%20Chinese%20person%20with%20mysterious%20expression%20warm%20dark%20background%20editorial%20portrait%20style&width=200&height=200&seq=comment-avatar-01&orientation=squarish',
  },
  {
    id: 2,
    author: '深夜不关机',
    role: '忠实用户',
    content: '作为一个吃了五年瓜的老用户，我敢说91吃瓜是全网最敢说真话的平台。别的平台要么删帖要么洗白，只有这里敢把实锤证据原原本本放出来。吃瓜就要吃真瓜，不吃洗白瓜！',
    avatar: 'https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20young%20adult%20with%20confident%20expression%20warm%20dark%20background%20professional%20headshot%20style&width=200&height=200&seq=comment-avatar-02&orientation=squarish',
  },
  {
    id: 3,
    author: '娱乐圈观察员',
    role: '行业人士',
    content: '说实话，圈内很多消息我们自己人都是在91吃瓜上先看到的。这个平台的信息源真的很广，从明星到网红到素人全覆盖，关键是爆料都有实锤支撑，不是那种空穴来风的谣言。',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20stylish%20person%20with%20analytical%20expression%20warm%20dark%20background%20editorial%20style&width=200&height=200&seq=comment-avatar-03&orientation=squarish',
  },
];

export const faqData = [
  {
    id: 1,
    question: '91吃瓜是什么平台？',
    answer: '91吃瓜是国内领先的娱乐爆料与实锤曝光平台，每日更新明星塌房、网红八卦、素人爆料等独家内容。我们坚持"有锤放锤、无锤不编"的原则，所有爆料均有实锤证据支撑，绝不传播虚假信息。平台涵盖娱乐圈、网红圈、校园圈等多个领域，是真正的吃瓜爱好者聚集地。',
  },
  {
    id: 2,
    question: '91吃瓜的爆料内容可信吗？',
    answer: '91吃瓜对每一条爆料内容都有严格的审核机制，所有"实锤曝光"标签下的内容必须附带可验证的证据材料，包括但不限于聊天记录截图、监控画面、录音文件等。我们拒绝发布未经证实的谣言和猜测性内容，这也是91吃瓜在吃瓜圈内口碑领先的核心原因。',
  },
  {
    id: 3,
    question: '如何向91吃瓜投稿爆料？',
    answer: '你可以通过页面的投稿入口向我们提交爆料信息。我们接受文字、图片、视频等多种形式的爆料材料。投稿人的个人信息将严格保密，我们采用端到端加密保护爆料人隐私。如果你的爆料被采纳发布且获得较高关注，还有机会获得爆料奖励。',
  },
  {
    id: 4,
    question: '91吃瓜和九一吃瓜网是什么关系？',
    answer: '91吃瓜是九一吃瓜网的官方品牌名称，两者为同一平台。目前91吃瓜在线是最新且唯一官方地址，请认准本站域名，谨防仿冒站点。所有"91吃瓜大事件"相关专题均可在本站完整查看，无需跳转其他页面。如果发现假冒网站，欢迎通过投稿入口向我们举报。',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-fire-line',
    title: '全网最快爆料节奏',
    description: '专业一线爆料团队全天候监控，明星塌房、网红翻车第一时间推送，比热搜快至少30分钟',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '实锤证据严格把关',
    description: '所有"实锤曝光"内容必须附带可验证证据，拒绝谣言和水军洗白，吃瓜就要吃真瓜',
  },
  {
    id: 3,
    icon: 'ri-group-line',
    title: '明星素人全覆盖',
    description: '从顶流艺人到校园素人，从头部网红到十八线小咖，全网黑料一网打尽，不漏任何爆点',
  },
  {
    id: 4,
    icon: 'ri-lock-line',
    title: '爆料人隐私保护',
    description: '多层加密保护投稿人信息，绝不泄露爆料来源，让你放心爆料无后顾之忧',
  },
  {
    id: 5,
    icon: 'ri-eye-line',
    title: '独家深扒不跟风',
    description: '专业调查团队深度挖掘事件真相，不做表面文章，每一条爆料都有来龙去脉',
  },
];

export const indexData = [
  {
    id: 1,
    title: '明星塌房实录',
    count: '186篇',
    image: 'https://readdy.ai/api/search-image?query=celebrity%20scandal%20breaking%20news%20collage%20style%20with%20dramatic%20dark%20red%20and%20black%20tones%20paparazzi%20aesthetic&width=600&height=450&seq=index-01&orientation=landscape',
    accent: true,
  },
  {
    id: 2,
    title: '网红翻车合集',
    count: '254篇',
    image: 'https://readdy.ai/api/search-image?query=influencer%20drama%20and%20controversy%20collage%20dark%20moody%20warm%20orange%20tones%20social%20media%20scandal%20aesthetic&width=600&height=450&seq=index-02&orientation=landscape',
    accent: false,
  },
  {
    id: 3,
    title: '素人爆料专区',
    count: '312篇',
    image: 'https://readdy.ai/api/search-image?query=anonymous%20tip%20and%20whistleblower%20scene%20with%20dark%20mysterious%20atmosphere%20warm%20red%20glow%20investigative%20style&width=600&height=450&seq=index-03&orientation=landscape',
    accent: false,
  },
  {
    id: 4,
    title: '娱乐圈内幕',
    count: '148篇',
    image: 'https://readdy.ai/api/search-image?query=behind%20the%20scenes%20entertainment%20industry%20dark%20atmosphere%20with%20curtains%20and%20spotlight%20warm%20red%20dramatic%20lighting&width=600&height=450&seq=index-04&orientation=landscape',
    accent: true,
  },
  {
    id: 5,
    title: '综艺节目争议',
    count: '97篇',
    image: 'https://readdy.ai/api/search-image?query=TV%20show%20drama%20and%20controversy%20on%20stage%20with%20dramatic%20warm%20spotlight%20dark%20background%20theatrical%20atmosphere&width=600&height=450&seq=index-05&orientation=landscape',
    accent: false,
  },
  {
    id: 6,
    title: '情感八卦现场',
    count: '421篇',
    image: 'https://readdy.ai/api/search-image?query=romantic%20scandal%20and%20relationship%20drama%20dark%20moody%20scene%20with%20warm%20pink%20and%20red%20tones%20emotional%20atmosphere&width=600&height=450&seq=index-06&orientation=landscape',
    accent: false,
  },
  {
    id: 7,
    title: '91吃瓜大事件',
    count: '73篇',
    image: 'https://readdy.ai/api/search-image?query=breaking%20news%20headline%20collage%20with%20dramatic%20dark%20red%20background%20warm%20explosive%20tones%20sensational%20journalism%20style&width=600&height=450&seq=index-07&orientation=landscape',
    accent: true,
  },
];

export const mediaData = [
  {
    id: 1,
    title: '顶流男星酒店监控完整版流出',
    info: '独家 · 时长 06:32 · 播放 892万',
    image: 'https://readdy.ai/api/search-image?query=surveillance%20footage%20style%20scene%20with%20hotel%20corridor%20dark%20grainy%20atmosphere%20warm%20security%20camera%20aesthetic%20mysterious%20vibe&width=900&height=506&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '综艺导师后台争吵实录音频曝光',
    info: '独家 · 时长 04:15 · 播放 567万',
    image: 'https://readdy.ai/api/search-image?query=audio%20waveform%20visualization%20with%20dark%20dramatic%20background%20warm%20orange%20and%20red%20tones%20podcast%20recording%20studio%20aesthetic&width=900&height=506&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '素人情侣互撕聊天记录全曝光',
    info: '独家 · 时长 11:48 · 播放 1,234万',
    image: 'https://readdy.ai/api/search-image?query=chat%20messages%20on%20phone%20screen%20with%20dramatic%20dark%20background%20warm%20glow%20social%20media%20scandal%20aesthetic%20digital%20drama&width=900&height=506&seq=media-03&orientation=landscape',
  },
];

export const topicsData = [
  { id: 1, name: '顶流塌房', hot: 982, trending: true },
  { id: 2, name: '网红翻车', hot: 876, trending: true },
  { id: 3, name: '素人爆料', hot: 754, trending: true },
  { id: 4, name: '综艺争议', hot: 632, trending: false },
  { id: 5, name: '情感吃瓜', hot: 598, trending: false },
  { id: 6, name: '选秀黑幕', hot: 521, trending: false },
  { id: 7, name: '直播事故', hot: 487, trending: false },
  { id: 8, name: '学术造假', hot: 445, trending: false },
  { id: 9, name: '品牌翻车', hot: 398, trending: false },
];

export const rankingData = [
  { id: 1, title: '顶流男星深夜密会网红，酒店监控实锤', hot: '爆', views: '892万' },
  { id: 2, title: '知名女主播偷税被罚千万，直播永久封禁', hot: '爆', views: '756万' },
  { id: 3, title: '选秀出道艺人被前经纪人举报造假', hot: '热', views: '634万' },
  { id: 4, title: '某男团队内不和实锤，后台争吵录音流出', hot: '热', views: '521万' },
  { id: 5, title: '网红夫妻婚变内幕：第三者竟为圈内好友', hot: '新', views: '398万' },
];

export const updatesData = [
  {
    id: 1,
    time: '2026-07-18 14:32',
    title: '顶流男星经纪公司发布声明：将采取法律手段',
    summary: '针对酒店监控视频流出事件，该男星经纪公司刚刚发布正式声明，称视频系恶意剪辑，已委托律师团队处理。',
    latest: true,
  },
  {
    id: 2,
    time: '2026-07-18 11:15',
    title: '偷税女主播名下豪车被法院查封',
    summary: '最新消息显示，涉嫌偷逃税款的女主播名下三辆豪车已被法院依法查封，冻结资产总额超五千万。',
    latest: true,
  },
  {
    id: 3,
    time: '2026-07-18 09:48',
    title: '综艺节目组回应导师冲突：正常节目效果',
    summary: '节目组官方账号发文称导师之间的争论属于正常节目录制过程中的观点交锋，否认存在实质性冲突。',
    latest: false,
  },
  {
    id: 4,
    time: '2026-07-17 22:30',
    title: '被举报艺人粉丝后援会宣布暂停应援活动',
    summary: '受学历造假举报影响，该艺人的全国粉丝后援会发布公告称将暂停一切应援活动，等待官方调查结果。',
    latest: false,
  },
  {
    id: 5,
    time: '2026-07-17 18:20',
    title: '男团经纪公司内部人士爆料：成员矛盾已持续半年',
    summary: '一位不愿具名的经纪公司内部人士向91吃瓜透露，该男团成员之间的不和已持续半年以上，公司多次调解无效。',
    latest: false,
  },
  {
    id: 6,
    time: '2026-07-17 15:05',
    title: '网红夫妻双方已删除所有合照',
    summary: '眼尖网友发现，涉婚变网红夫妻的社交账号已互相取关，并清空了所有历史合照内容，婚变传闻基本坐实。',
    latest: false,
  },
  {
    id: 7,
    time: '2026-07-16 20:45',
    title: '新任爆料人提供男团后台完整视频',
    summary: '91吃瓜收到新爆料人提供的男团后台争吵完整视频，时长约15分钟，目前正在进行真实性核验。',
    latest: false,
  },
  {
    id: 8,
    time: '2026-07-16 16:00',
    title: '税务部门确认将对网红行业开展专项稽查',
    summary: '受女主播偷税案影响，税务部门相关人士透露将在近期对全网头部网红开展专项税务稽查行动。',
    latest: false,
  },
];

export const carouselData = [
  {
    id: 1,
    title: '【深度专题】2026上半年明星塌房大盘点',
    summary: '半年内7位顶流艺人接连翻车，从偷税到私生活混乱，91吃瓜独家梳理每一起塌房事件的完整时间线与关键证据。',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20breaking%20news%20headline%20collage%20with%20multiple%20celebrity%20scandals%20dark%20red%20background%20warm%20tones%20sensational%20magazine%20cover%20style&width=1000&height=600&seq=carousel-01&orientation=landscape',
    accent: true,
  },
  {
    id: 2,
    title: '【独家深扒】网红圈灰色产业链全揭秘',
    summary: '从数据造假到人设营销，91吃瓜调查团队深入追踪网红圈背后的灰色产业链，揭开那些不为人知的行业内幕。',
    image: 'https://readdy.ai/api/search-image?query=investigative%20journalism%20scene%20with%20dark%20mysterious%20atmosphere%20documents%20on%20desk%20warm%20orange%20spotlight%20detective%20style&width=1000&height=600&seq=carousel-02&orientation=landscape',
    accent: false,
  },
  {
    id: 3,
    title: '【素人爆料季】校园里的那些惊人内幕',
    summary: '每年的毕业季都是素人爆料的高峰期，今年更是猛料不断。从学术不端到校园恋情，91吃瓜精选最热校园爆料合集。',
    image: 'https://readdy.ai/api/search-image?query=campus%20drama%20and%20student%20life%20controversy%20dark%20academic%20atmosphere%20with%20warm%20light%20through%20windows%20mysterious%20vibe&width=1000&height=600&seq=carousel-03&orientation=landscape',
    accent: false,
  },
  {
    id: 4,
    title: '【证据链】那些被实锤砸到无法翻身的明星',
    summary: '有些明星面对实锤选择沉默，有些选择否认，但证据面前一切辩解都苍白无力。回顾那些被铁证定性的经典塌房案例。',
    image: 'https://readdy.ai/api/search-image?query=evidence%20and%20documents%20spread%20on%20dark%20table%20with%20dramatic%20warm%20red%20lighting%20crime%20investigation%20board%20aesthetic&width=1000&height=600&seq=carousel-04&orientation=landscape',
    accent: true,
  },
];